module.exports = __webpack_public_path__ + "media/identify/icon_third-6acd8c4a.svg";